export enum PlanOrder {
  primary = 1,
  secondary = 2,
  tertiary = 3,
}
